import { render, staticRenderFns } from "./AreaNotes.vue?vue&type=template&id=7359e734&scoped=true"
import script from "./AreaNotes.vue?vue&type=script&lang=ts"
export * from "./AreaNotes.vue?vue&type=script&lang=ts"
import style0 from "./AreaNotes.vue?vue&type=style&index=0&id=7359e734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7359e734",
  null
  
)

export default component.exports